/**
 * Hands a Blob fetched with the session to the browser as a file download (the same
 * object-URL pattern as the CRM contact export, admin/CrmAdmin.jsx). The object URL is
 * revoked once the click has been dispatched.
 *
 * @param {Blob} blob
 * @param {string} filename
 */
export default function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
